import { useEffect, useRef, useState } from 'react';

import PropTypes from 'prop-types';
import { Visualizer } from '../../components/Visualizer/Visualizer';
import { FenceDiagramScheme } from './FenceDiagram.helper';
import { getImageFile } from 'utils/utils';

const containerId = 'fence-visualizer';

export const FenceDiagram = ({ fenceInfo, height, width }) => {
  const canvasContainerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [downloadURL, setDownloadURL] = useState(null);
  const animationRef = useRef(0);
  const stageRef = useRef(null);
  //   const dispatch = useAppDispatch();
  const setPositionRef = useRef(null);

  useEffect(() => {
    setIsLoading(true);
    return () => {
      stageRef.current?.destroy();
    };
  }, []);

  useEffect(() => {
    const canvasContainer = canvasContainerRef.current;

    if (canvasContainer) {
      const fenceScheme = new FenceDiagramScheme({
        bgColor: '#c8c8c8',
        containerId,
        containerHeight: height,
        containerWidth: width,
        fenceInfo,
        onFinish: (downloadURL) => {
          getImageFile(downloadURL);
          setIsLoading(false);
          setDownloadURL(downloadURL);
        }
      });
      stageRef.current = fenceScheme.stage;
      setPositionRef.current = () => {
        fenceScheme.setInitPositions();
      };

      const update = () => {
        fenceScheme.stage.batchDraw();
        animationRef.current = requestAnimationFrame(update);
      };

      update();

      return () => {
        cancelAnimationFrame(animationRef.current);
      };
    }
  }, [fenceInfo]);

  return (
    <Visualizer
      downloadURL={downloadURL}
      height={height}
      id={containerId}
      isLoading={isLoading}
      ref={canvasContainerRef}
      setInitPosition={setPositionRef.current}
      title={`Total clamps: ${fenceInfo?.clamp_deck_list?.qty}`}
      width={width}
    />
  );
};

FenceDiagram.propTypes = {
  fenceInfo: PropTypes.object,
  height: PropTypes.number,
  width: PropTypes.number
};
